export const RECHARGE_ROUTES_URL = {
  WALLET: '/recharge-requests/wallet',
  BOSTA_CREDITS: '/recharge-requests/bosta-credits'
};

export const DD_MMM_DATE_FORMAT = 'ddd, DD MMM';
export const HH_MM_TIME_FORMAT = 'HH:mm';
